import { render, staticRenderFns } from "./ManageEcommerce.vue?vue&type=template&id=3005934d"
import script from "./ManageEcommerce.vue?vue&type=script&lang=js"
export * from "./ManageEcommerce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports